export default "__VITE_ASSET__CdgIJkaX__"